"use client"

import {
  Toaster as ChakraToaster,
  Portal,
  Spinner,
  Stack,
  Toast,
  createToaster,
} from "@chakra-ui/react"

// Top-center like mobile's toast, so it never collides with the phone TabBar.
export const toaster = createToaster({
  placement: "top",
  pauseOnPageIdle: true,
})

/** Mobile's toast colours: ink for success, red for errors, pale paper for info. */
const KIND: Record<string, { bg: string; color: string; border: string }> = {
  success: { bg: "var(--primary)", color: "var(--on-primary)", border: "transparent" },
  error: { bg: "var(--error)", color: "#ffffff", border: "transparent" },
  info: { bg: "var(--surface-container-high)", color: "var(--on-surface)", border: "var(--outline-variant)" },
  loading: { bg: "var(--surface-container-high)", color: "var(--on-surface)", border: "var(--outline-variant)" },
}

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
        {(toast: any) => {
          const kind = KIND[toast.type] ?? KIND.info
          return (
            <Toast.Root
              width={{ md: "sm" }}
              bg={kind.bg}
              color={kind.color}
              borderWidth="1px"
              borderColor={kind.border}
              borderRadius="1rem"
              boxShadow="0 4px 12px rgba(28,27,25,0.14)"
              fontFamily="var(--font-body)"
            >
              {toast.type === "loading" && <Spinner size="sm" color="var(--accent)" />}
              <Stack gap="0.5" flex="1" maxWidth="100%">
                {toast.title && <Toast.Title fontWeight="500" fontSize="0.875rem">{toast.title}</Toast.Title>}
                {toast.description && (
                  <Toast.Description fontSize="0.8125rem" opacity={0.85}>{toast.description}</Toast.Description>
                )}
              </Stack>
              {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
              {toast.closable && <Toast.CloseTrigger />}
            </Toast.Root>
          )
        }}
      </ChakraToaster>
    </Portal>
  )
}
